import { fetchApiData, updateApiData } from "../../utils/utils";

export const fetchBundles = async (appInfo, tokenId = null) => {
  try {
    const response = await fetchApiData(
      appInfo,
      "bundles/list",
      tokenId ? { token_id: tokenId } : {}
    );

    if (!response?.data) {
      return {
        success: false,
        error: response?.message || "Failed to load bundles",
        status: response?.status,
      };
    }

    return {
      success: true,
      data: response?.data
    };

  } catch (error) {
    console.error('Bundles API error:', error);
    console.error('Error response:', error.response);
    
    // Don't redirect on 404, just return error
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      status: error.response?.status
    };
  }
};

export const payBundle = async (appInfo, bundleId, paymentChoice) => {
  try {
    const location = {
      path: "bundleCheckout",
      values: {
        bundle_id: bundleId,
        consent: true,
        payment_choice: paymentChoice,
      },
    };

    const response = await updateApiData(
      appInfo,
      "bundles/checkout",
      location
    );

    if (response?.success === false) {
      return {
        success: false,
        error: response?.message || "Request failed",
        status: response?.status,
      };
    }

    return {
      success: true,
      data: response?.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
    };
  }
};

export const createCheckoutSession = async (appInfo, bundleId) => {
  try {
    const location = {
      path: "bundleCheckout",
      values: {
        bundle_id: bundleId,
      },
    };

    const response = await updateApiData(
      appInfo,
      "bundles/checkout",
      location
    );

    if (response?.success === false) {
      return {
        success: false,
        error: response?.message || "Request failed",
        status: response?.status,
      };
    }

    return {
      success: true,
      data: response?.data
    };

  } catch (error) {
    console.error('Checkout session error:', error);
    console.error('Error response:', error.response);
    
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      status: error.response?.status
    };
  }
};

export const updateBundlePayment = async (
  appInfo,
  bundleId,
  paymentMethod,
  paymentRef,
  pricePaid,
  currencyId
) => {
  const values = {
    bundle_id: bundleId,
    payment_method: paymentMethod,
    payment_ref: paymentRef,
    price: pricePaid,
    currency_id: currencyId,
  };

  const location = {
    path: "bundlePurchase",
    values,
  };

  return await updateApiData(appInfo, "bundles/purchase", location);
};
